import styled from 'styled-components';
import CallToAction from 'contentful/shared/call_to_action';
import { white, cefRed, grey3, secondaryTextColor } from 'constants/variables';
import toRem from 'utils/toRem';
import responsive from 'utils/responsive';

const ScheduleItem = ({
  dateTime,
  title,
  description,
  callToAction,
  hasGreyBackground,
}) => (
  <Item hasGreyBackground={hasGreyBackground} className="schedule-item">
    <Date>{dateTime}</Date>
    <div>
      <Title>{title}</Title>
      <Description>{description}</Description>
    </div>
    {callToAction && (
      <CallToAction
        id={callToAction.sys.id}
        content={callToAction.fields}
        newTab
      />
    )}
  </Item>
);

const Item = styled.div`
  background-color: ${({ hasGreyBackground }) =>
    hasGreyBackground ? grey3 : white};
  padding: ${toRem(16)} ${toRem(24)};
  display: grid;
  grid-template-columns: 1fr;
  gap: ${toRem(8)};

  ${responsive('tabletSmall')} {
    grid-template-columns: 120px 1fr auto;
    gap: ${toRem(52)};
  }
`;

const Date = styled.div`
  color: ${cefRed};
  font-size: ${toRem(16)};
  font-weight: 700;
  line-height: ${toRem(24)};
`;

const Title = styled.h3`
  .schedule-item & {
    font-size: ${toRem(20)};
    line-height: ${toRem(24)};
    margin-top: 0;
    margin-bottom: ${toRem(8)};
  }
`;

const Description = styled.p`
  color: ${secondaryTextColor};
  margin-bottom: 0;
`;

export default ScheduleItem;
